
export const getDomainId = () => {
    return new Promise((resolve,reject)=>{
        let domainId = sessionStorage.getItem('domainId');
        if (!domainId && typeof window !== 'undefined') {
            const params = new URLSearchParams(window.location.search);
            domainId = params.get('domain_id');
            if (domainId) {
                sessionStorage.setItem('domainId', domainId);
                resolve(domainId)
            }
            else{
                reject('')
            }
        }
        else if(domainId !== "")
        {
            resolve(domainId);
        }
        else
        {
            reject('');
        }
    })
};

export const getDomainIdSync = () => {
    let domainId = sessionStorage.getItem('domainId');
    if (!domainId && typeof window !== 'undefined') {
        const params = new URLSearchParams(window.location.search);
        domainId = params.get('domain_id');
        if (domainId) {
            sessionStorage.setItem('domainId', domainId);
            return domainId;
        }
        else{
            return '';
        }
    }
    else if(domainId !== "")
    {
        return domainId;
    }
    else
    {
        return "";
    }
};
